import MappingResponseModel from "../Models/MappingResponseModel";

export default class MappingFactory {
  public remapToResponseModel = (
    idMappings: Map<string, string>,
    input: string,
    output: string
  ): MappingResponseModel => {
    const responseModel = new MappingResponseModel();

    responseModel.meta.input = input;
    responseModel.meta.output = output;

    if (idMappings.size === 0) {
      return responseModel;
    }

    responseModel.data = Array.from(idMappings).map(([input, output]) => {
      return {
        input,
        output,
      };
    });

    return responseModel;
  };
}
